// extracted by mini-css-extract-plugin
module.exports = {"root":"ChartCard_root__2Sec3","content":"ChartCard_content__2q_M7","header":"ChartCard_header__2BFDK","title":"ChartCard_title__2OZyk","subTitle":"ChartCard_subTitle__26w1w"};